export default function phoneMask(phone) {
  if (!phone) return ''

  const rawPhone = String(phone)

  const parts = rawPhone
    .replace(/[^0-9]/g, '')
    .match(/(\d{0,2})(\d{0,5})(\d{0,4})/)

  return `(${parts[1]}${parts[2] !== '' ? ') ' : ''}${parts[2]}${
    parts[3] !== '' ? '-' : ''
  }${parts[3]}`
}
